// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('acRemLtr', {
//         templateUrl: 'views/components/views/acRemLtr/acRemLtr.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'acRemLtrService', 'emailCreateService', function ($stateParams, stateService, modalService, translateService, acRemLtrService, emailCreateService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let businessCoNo = $stateParams.businessco_no;
//             let acRemLtrKeyno = $stateParams.acremltr_keyno;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 emailTemplateListButtons: [
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('emailtemplates') }
//                 ],
//                 emailTemplateEditButtons: [
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('emailtemplates') },
//                     { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('emailtemplate', { emailtemplate_keyno: vm.model.edit.emailtemplate_keyno }) }
//                 ],
//                 edit: {},
//                 selectListEmailTemplates: [],
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await acRemLtrService.getEdit({
//                     businessco_no: businessCoNo,
//                     acremltr_keyno: acRemLtrKeyno
//                 }))[0];
//             }

//             async function loadEmailTemplates() {
//                 vm.model.selectListEmailTemplates = await emailCreateService.listEmailTemplates({ webpage: 'acreminderproposal' });
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS
            
//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 acRemLtrService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadEmailTemplates();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
